import { render, staticRenderFns } from "./ReportRequestIndex.vue?vue&type=template&id=9b742d78&scoped=true&"
import script from "./ReportRequestIndex.vue?vue&type=script&lang=js&"
export * from "./ReportRequestIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReportRequestIndex.vue?vue&type=style&index=0&id=9b742d78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b742d78",
  null
  
)

export default component.exports